import AnnualPeriodsError from './AnnualPeriodsError';
class AnnualPeriodsInvalidNumberOfYears extends AnnualPeriodsError {
    numberOfYears;
    constructor(numberOfYears, options) {
        super('The number of years is not a number', options);
        this.numberOfYears = numberOfYears;
    }
}
export default AnnualPeriodsInvalidNumberOfYears;
